import React, { useState } from "react";
import AiFeatureToolPrep from "../../shared/Popup/AiFeatureToolPrep";
import AiPresetCards from "../../shared/Popup/AiPresetCards";
import { presetTip } from "../../shared/Popup/presetTip";

const STRENGTHS = [
  {
    id: "gentle",
    label: "Gentle",
    sub: "Preserve grain",
    tip: presetTip('Gentle — "Preserve grain"', [
      "Light scratch and fade repair",
      "Keeps more of the original film look",
    ]),
  },
  {
    id: "balanced",
    label: "Balanced",
    sub: "Recommended",
    tip: presetTip('Balanced — "Recommended"', [
      "Repairs scratches, dust, and mild damage",
      "Natural color and contrast recovery",
    ]),
  },
  {
    id: "deep",
    label: "Deep",
    sub: "Heavy damage",
    tip: presetTip('Deep — "Heavy damage"', [
      "Strong reconstruction for torn or faded photos",
      "May smooth fine original texture",
    ]),
  },
];

/**
 * AI Tools → AI Old Photo Restoration prep.
 */
const OldPhotoRestoreToolPrep = (props) => {
  const [strengthId, setStrengthId] = useState("balanced");
  const [prompt, setPrompt] = useState("");

  return (
    <AiFeatureToolPrep
      {...props}
      toolKey="ai_old_photo_restore"
      title="AI Old Photo Restoration"
      aka="Photo Restorer"
      bio="Repair scratches, fade, and noise in old photos."
      emptyPreviewLabel="Upload an old photo to preview restoration"
      loadingLabel="Restoring photo…"
      emptyFooterHint="Upload a photo, pick restoration strength, then generate."
      renderControls={({ busy, leftPanelRef }) => (
        <>
          <div className="aftp-section">
            <p className="aftp-label">Restoration</p>
            <AiPresetCards
              presets={STRENGTHS}
              selectedId={strengthId}
              ariaLabel="Restoration strength"
              boundaryRef={leftPanelRef}
              disabled={busy}
              onSelect={(id) => {
                setStrengthId(id);
              }}
            />
          </div>
          <div className="aftp-section">
            <label className="aftp-label" htmlFor="aftp-opr-prompt">
              Notes <span className="aftp-optional">(optional)</span>
            </label>
            <textarea
              id="aftp-opr-prompt"
              className="aftp-input"
              rows={3}
              value={prompt}
              onChange={(e) => {
                setPrompt(e.target.value);
              }}
              placeholder="e.g. fix tear on the left, keep skin tones natural"
              disabled={busy}
            />
          </div>
        </>
      )}
    />
  );
};

export default OldPhotoRestoreToolPrep;
